import { render, staticRenderFns } from "./TablaComponente.vue?vue&type=template&id=4cd915dc&scoped=true"
import script from "./TablaComponente.vue?vue&type=script&lang=js"
export * from "./TablaComponente.vue?vue&type=script&lang=js"
import style0 from "./TablaComponente.vue?vue&type=style&index=0&id=4cd915dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd915dc",
  null
  
)

export default component.exports